import { Checkbox, FormControl, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { KeyboardEvent, KeyboardEventHandler, useState } from 'react';

interface MultiSelectProps {
  localValue: string[];
  options?: string[];
  handleSave: (value: string | string[]) => void;
  onClose: () => void;
  onKeyDown: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const MultiSelect = ({ localValue, options, handleSave, onClose, onKeyDown }: MultiSelectProps) => {
  const [currentValue, setCurrentValue] = useState<string[]>(localValue);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value }
    } = event;
    setCurrentValue(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <FormControl
      sx={{ minHeight: '1rem', lineHeight: 1 }}
      fullWidth>
      <Select
        id="edit-component-multi-select"
        multiple
        size="small"
        data-testid="edit-component-multi-select"
        value={currentValue}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            onClose();
            return;
          }
          onKeyDown(e);
        }}
        renderValue={(selected) => (selected as string[]).join(', ')}
        MenuProps={{
          slotProps: {
            list: {
              onKeyDown: (e: KeyboardEvent<HTMLUListElement>) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleSave(currentValue);
                  onClose();
                }
              }
            }
          },
          onClose: (event, reason) => {
            if (reason === 'escapeKeyDown') {
              onClose();
            }
            if (reason === 'backdropClick') {
              handleSave(currentValue);
              onClose();
            }
          }
        }}>
        {options?.length &&
          options.map((op) => (
            <MenuItem
              key={op}
              value={op}>
              <Checkbox checked={currentValue.indexOf(op) > -1} />
              <ListItemText primary={op || '--None--'} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
